import { render, staticRenderFns } from "./IconAttachment.vue?vue&type=template&id=0ead56e8"
import script from "./IconAttachment.vue?vue&type=script&lang=js"
export * from "./IconAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports